import { createSlice } from "@reduxjs/toolkit";

const choosePickSlice = createSlice({
  name: "choosePick",
  initialState: {
    loading: false,
    error: false,
    v2Fixtures: [],
    confrimPopup: {
      openPopup: false,
      updateFixture: false,
    },
  },
  reducers: {
    updateLoadingStatus: (state) => {
      state.loading = true;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateConfirmPopup: (state, action) => {
      state.confrimPopup = {
        ...state.confrimPopup,
        openPopup: action.payload.openPopup,
        updateFixture:action.payload.updateFixture,
      };
    },
    fetchPotFixtures: (state, action) => {
      state.loading = true;
      state.error = false;
      state.v2Fixtures = action.payload;
    },
    updateSelectedFixtures: (state, action) => {
      state.loading = false;
      state.error = false;

      state.v2Fixtures = state.v2Fixtures.map((fixture) => ({
        ...fixture,
        selected:
          fixture.id === action.payload.id ? action.payload.selected : false,
      }));
    },
  },
});

export const {
  updateConfirmPopup,
  updateLoadingStatus,
  updateErrStatus,
  fetchPotFixtures,
  updateSelectedFixtures,
} = choosePickSlice.actions;

export default choosePickSlice.reducer;
